import { useEffect, useReducer, useRef, useState } from "react";
import { isCanceled } from "../api/client";

export const refreshRecords = () => {
  window.dispatchEvent(new Event("attar:records-changed"));
  try { window.localStorage.setItem("attar.records.updated", String(Date.now())); } catch { /* Same-tab refresh still works. */ }
};
export default function useRemote(load, key = "", enabled = true) {
  const loader = useRef(load);
  const [revision, reload] = useReducer((value) => value + 1, 0);
  const [state, setState] = useState({ data: null, loading: enabled, error: null });
  useEffect(() => { loader.current = load; });
  useEffect(() => {
    const changed = (event) => { if (event.key === "attar.records.updated") reload(); };
    window.addEventListener("attar:records-changed", reload);
    window.addEventListener("storage", changed);
    return () => { window.removeEventListener("attar:records-changed", reload); window.removeEventListener("storage", changed); };
  }, []);
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    setState({ data: null, loading: true, error: null });
    Promise.resolve().then(() => loader.current(controller.signal)).then(
      (data) => { if (!controller.signal.aborted) setState({ data, loading: false, error: null }); },
      (error) => { if (!controller.signal.aborted && !isCanceled(error)) setState({ data: null, loading: false, error }); }
    );
    return () => controller.abort();
  }, [key, revision, enabled]);
  return { ...state, reload };
}
